import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';

const VerifyEmailPage = () => {
  const location = useLocation();
  const [status, setStatus] = useState('working');
  const [message, setMessage] = useState('Verifying your email…');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }
    axios.get(`/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => {
        setStatus('ok');
        setMessage('Your email has been verified. You can close this tab and return to the game.');
      })
      .catch((err) => {
        setStatus('error');
        const reason = err?.response?.data?.reason;
        if (reason === 'expired_token') {
          setMessage('This verification link has expired. Please sign in and request a fresh one from the banner.');
        } else {
          setMessage('This verification link is not valid. Please request a new one.');
        }
      });
  }, [location.search]);

  return (
    <div className="auth-container">
      <div className="auth-form fade-in" style={{ textAlign: 'center' }}>
        <h2>Email Verification</h2>
        <p style={{
          color: status === 'ok' ? '#8fd98f' : status === 'error' ? '#d98f8f' : '#ccc',
          marginTop: 20,
          marginBottom: 20,
        }}>
          {message}
        </p>
        <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block' }}>
          Return to Login
        </Link>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
